import toast from 'components/partials/toast/toast';

import { DELETE_SUCCESS } from 'containers/admin/clients/client/tabs-components/critical-populations/critical-populations.constants';
import { notifyCaptureError } from 'containers/admin/clients/client/tabs-components/critical-populations/notify-capture-error';

import { useDeleteCriticalPopulation } from 'hooks/api/use-critical-populations';

interface UseDeleteCaptureArgs {
  clientId: number;
  id: number;
  onDeleted: () => void;
  onClose: () => void;
}

interface UseDeleteCaptureResult {
  isPending: boolean;
  handleConfirm: () => Promise<void>;
}

export const useDeleteCapture = ({
  clientId,
  id,
  onDeleted,
  onClose,
}: UseDeleteCaptureArgs): UseDeleteCaptureResult => {
  const { mutateAsync, isPending } = useDeleteCriticalPopulation(clientId);

  const handleConfirm = async (): Promise<void> => {
    try {
      await mutateAsync(id);
      toast.success(DELETE_SUCCESS);
      onDeleted();
    } catch (error) {
      if (notifyCaptureError(error)) onClose();
    }
  };

  return { isPending, handleConfirm };
};
